import React, { Component } from 'react';
import videoBG from '../assets/images/background/video-one-bg.png';
import { graphql, StaticQuery } from 'gatsby';
import VideoImg from './VideoImg';
import VideoModal from './VideoModal';

export default class Video extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  openModal = () => {
    this.setState({ isOpen: true });
  };

  render() {
    return (
      <section className='video-one' id='video'>
        <img src={videoBG} alt='alter text' className='video-one__bg' />
        <div className='container wow fadeInUp' data-wow-duration='1500ms'>
          <div className='video-one__box '>
            <VideoImg />
            <div className='video-one__content'>
              <VideoModal
                isOpen={this.state.isOpen}
                onClose={() => this.setState({ isOpen: false })}
              />
              <div
                onClick={this.openModal}
                onKeyDown={this.openModal}
                role='button'
                tabIndex='-1'
                className='video-popup video-one__btn'
              >
                <i className='fa fa-play'></i>
              </div>
              <StaticQuery
                query={graphql`
                  {
                    strapiHomePage {
                      video_heading
                    }
                  }
                `}
                render={(data) => (
                  <h2 className='video-one__title'>
                    {data.strapiHomePage.video_heading}
                  </h2>
                )}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
